import React from 'react';
import styled from 'styled-components';
import { marked } from 'marked';
import { ContentfulArticle } from './Blog';

const Card = styled.a`
  display: block;
  margin-bottom: 16px;
  overflow: hidden;
  background: #f8f8f8;
  border-radius: 16px;
  text-decoration: none;
`;

const Image = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left;
  }
`;

const Content = styled.div`
  padding: 24px;

  @media (min-width: 1024px) {
    padding: 32px;
  }
`;

const Title = styled.p`
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
  letter-spacing: -0.36px;
  margin: 0 0 8px;
`;

const StyledDate = styled.p`
  color: #7c7c7c;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.33px;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 36px;
  }
`;

const Excerpt = styled.div`
  p {
    font-size: 16px;
  }

  figure, img, video, iframe {
    display: none;
  }
`;

interface ArticleCardProps {
  article: ContentfulArticle;
  blogUrl?: string;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ article, blogUrl }) => {
  const { slug, featuredMedia, title, date, excerpt } = article.fields;
  const imageUrl = featuredMedia?.fields.file?.url;
  const displayDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: '2-digit'
  });

  return (
    <Card href={`${blogUrl}/${slug}`}>
      {(imageUrl) && (
        <Image>
          <img src={`https:${imageUrl}`} />
        </Image>
      )}
      <Content>
        <Title>{title}</Title>
        {date && (
          <StyledDate>{displayDate}</StyledDate>
        )}
        {(excerpt) && (
          <Excerpt dangerouslySetInnerHTML={{__html: marked(excerpt)}} />
        )}
      </Content>
    </Card>
  );
};

export default ArticleCard;
